export default "/_next/static/chunks/fonts/TheinhardtLightItalic-51c199312f3b43f6ce00d19756015108.woff";